const FETCH_MATERIAL_TYPES= "FETCH_MATERIAL_TYPES";
const FETCH_MATERIAL_TYPES_SUCCESS = "FETCH_MATERIAL_TYPES_SUCCESS";
const FETCH_MATERIAL_TYPES_ERROR = "FETCH_MATERIAL_TYPES_ERROR";
const FETCH_BOLT_TYPES = "FETCH_BOLT_TYPES";
const FETCH_BOLT_TYPES_SUCCESS = "FETCH_BOLT_TYPES_SUCCESS";
const FETCH_BOLT_TYPES_ERROR = "FETCH_BOLT_TYPES_ERROR";
const UPDATE_MATERIAL_TYPES = "UPDATE_MATERIAL_TYPES";
const UPDATE_MATERIAL_TYPES_SUCCESS = "UPDATE_MATERIAL_TYPES_SUCCESS";
const UPDATE_MATERIAL_TYPES_ERROR = "UPDATE_MATERIAL_TYPES_ERROR";
const DELETE_MATERIAL_TYPES = "DELETE_MATERIAL_TYPES";
const DELETE_MATERIAL_TYPES_SUCCESS = "DELETE_MATERIAL_TYPES_SUCCESS";
const DELETE_MATERIAL_TYPES_ERROR = "DELETE_MATERIAL_TYPES_ERROR";
const CREATE_MATERIAL_TYPES = "CREATE_MATERIAL_TYPES";
const CREATE_MATERIAL_TYPES_SUCCESS = "CREATE_MATERIAL_TYPES_SUCCESS";
const CREATE_MATERIAL_TYPES_ERROR = "CREATE_MATERIAL_TYPES_ERROR";
const IS_ADDING_UPDATE = "IS_ADDING_UPDATE";
const UPDATE_MATERIAL_TYPES_ORDER = "UPDATE_MATERIAL_TYPES_ORDER";
const UPDATE_MATERIAL_TYPES_ORDER_SUCCESS = "UPDATE_MATERIAL_TYPES_ORDER_SUCCESS";
const UPDATE_MATERIAL_TYPES_ORDER_ERROR = "UPDATE_MATERIAL_TYPES_ORDER_ERROR";

export {
  FETCH_MATERIAL_TYPES,
  FETCH_MATERIAL_TYPES_SUCCESS,
  FETCH_MATERIAL_TYPES_ERROR,
  FETCH_BOLT_TYPES,
  FETCH_BOLT_TYPES_SUCCESS,
  FETCH_BOLT_TYPES_ERROR,
  UPDATE_MATERIAL_TYPES,
  UPDATE_MATERIAL_TYPES_SUCCESS,
  UPDATE_MATERIAL_TYPES_ERROR,
  DELETE_MATERIAL_TYPES,
  DELETE_MATERIAL_TYPES_SUCCESS,
  DELETE_MATERIAL_TYPES_ERROR,
  CREATE_MATERIAL_TYPES,
  CREATE_MATERIAL_TYPES_SUCCESS,
  CREATE_MATERIAL_TYPES_ERROR,
  UPDATE_MATERIAL_TYPES_ORDER,
  UPDATE_MATERIAL_TYPES_ORDER_SUCCESS,
  UPDATE_MATERIAL_TYPES_ORDER_ERROR,
  IS_ADDING_UPDATE,
};
